import React from "react"
import Stub from "../Stub"

const BandejaEnvios = () => (
  <Stub
    title="Bandeja de envíos"
    icon="mdi-inbox-multiple-outline"
    descripcion="Explorador con filtros avanzados de todos los correos enviados"
    alcance={[
      "Tabla paginada con búsqueda por CUFE/prefijo+folio/destinatario",
      "Filtros: estado (pending, processing, sent_full, sent_partial, failed, definitivo, skipped), rango fechas, prefijo, folio",
      "Badge coloreado por estado + counter de OK/Fail por destinatario",
      "Acciones inline: ver detalle (drawer), reenviar, descargar ZIP",
      "Vista compacta y vista detallada con timeline embebido",
      "Export a CSV/Excel del listado filtrado",
    ]}
    endpoints={[
      { method: "GET", path: "/a7/inbox?nitemisor=X&estado=…&limit=…", desc: "Listado paginado" },
      { method: "GET", path: "/a7/inbox/{cufe}/full", desc: "Drawer de detalle con timeline" },
      { method: "GET", path: "/a7/inbox/{cufe}/historial", desc: "Cambios de estado del CUFE" },
      { method: "POST", path: "/a7/reenviar", desc: "Acción rápida desde la fila" },
      { method: "POST", path: "/a7/zip/generate", desc: "Descargar ZIP firmado" },
    ]}
  />
)

export default BandejaEnvios
